
const $ = jQuery;

window.jQuery = jQuery;

jQuery(document).ready(function () {
    function CheckDate() {
        var curYears = $('#prdCom').val();



        $('.list.list--w-label li').each(function () { //Loop through each option
           if(curYears != 0 && $(this).attr('class') != curYears){
               $(this).hide();
           } else {
                $(this).show();
            }
        });

    }

    CheckDate(); //Call the function when we run the page (at bottom of page, or within $(document).ready or something similar)
    $('#prdCom').on('change', function() { //When we change the project, call the function
        CheckDate();
    });

});


// WEBPACK FOOTER //
// ../work/src/js/actualite.js